<div class="d-inline-flex text-truncate mw-100">
  @for (houseConsignment of houseConsignments; track houseConsignment; let i = $index) {
    @if (i === 0) {
      <span class="cursor-pointer underline-tertiary link-underline-tertiary link-primary text-body"
            (click)="editHouseConsignment(houseConsignment)">
        <app-highlight [term]="term" [result]="houseConsignment"></app-highlight>
      </span>
    }
  }
  @if (houseConsignments?.length > 1) {
    <button onPopover data-bs-toggle="popover" [popoverContent]="popoverContent" placement="auto"
            popoverClass="pop-auto-container" class="btn btn-link link-dark p-0 ms-2">
      +{{ houseConsignments.length - 1 }}
    </button>
  }
</div>

<ng-template #popoverContent>
  <div class="w-100 h-100 text-start p-1 pe-4" [style.max-width.px]="320">
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0 mt-2 me-2">
      <button type="button" class="btn-close" data-bs-toggle="popover" aria-label="Close"></button>
    </div>
    <div class="row gy-3">
      @for (houseConsignment of houseConsignments; track houseConsignment) {
        <div class="col-12">
          <button class="btn btn-plain p-0" data-bs-toggle="popover" (click)="editHouseConsignment(houseConsignment)">
            {{ houseConsignment }}
          </button>
        </div>
      }
    </div>
  </div>
</ng-template>
